export { default } from "../../design-system/layout/ResponsiveContainer";


// WEBPACK FOOTER //
// ./src/_components/ResponsiveContainer/index.jsx